module.exports = __webpack_public_path__ + "static/woman-he-8fda1f4fc93a3ab10c351779daf54744.jpg";